import React from "react";
import { Route, Redirect } from "react-router-dom";
import { loadUserDetailsFromLocalStorage } from "../store/index";

const PrivateRoute = ({ component: Component, render, ...rest }) => {
  const userDetails = loadUserDetailsFromLocalStorage();
  const apiToken = typeof window !== 'undefined' ? localStorage.getItem('apiToken') : null;
  const isStoreOpen = typeof window !== 'undefined' ? localStorage.getItem('isStoreOpen') : null;

  // Require a valid apiToken and saved userDetails. Also, if the app is in "store open"
  // guest mode (isStoreOpen === 'true'), block access to protected routes.
  const isAuth = !!userDetails && !!apiToken && isStoreOpen !== 'true';
  return (
    <Route
      {...rest}
      render={(props) => {
        if (isAuth) {
          if (Component) return <Component {...props} />;
          if (render) return render(props);
          return null;
        }

        // Save attempted path so login can redirect back after success
        try {
          const redirectPath = props.location.pathname + (props.location.search || "");
          localStorage.setItem("postLoginRedirect", redirectPath);
        } catch (e) {
          // ignore
        }

        return <Redirect to="/login" />;
      }}
    />
  );
};

export default PrivateRoute;
